import { CompanySettings } from '@components/settings/company-settings'
import DashboardLayout from "@pma/app/dashboard/layout";


const SettingsPage = () => {
  return (
    <DashboardLayout>
      <div className='grid gap-8 pb-12'>
        <CompanySettings />
      </div>
    </DashboardLayout>
  )
}

export default SettingsPage
